import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

import SidePanel from './SidePanel';

const InputHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const InputTitle = styled.p`
  color: ${tokens.color_label_dark_gray};
  font-weight: 700;
  font-size: 12px;
  padding: 0;
  margin: 8px 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, Roboto, Helvetica Neue, Arial,
    sans-serif;
`;

const InputReset = styled.a`
  text-decoration: none;
  color: ${tokens.color_brand_primary};
  font-size: 12px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, Roboto, Helvetica Neue, Arial,
    sans-serif;

  :hover {
    color: #0757b2;
  }

  :active {
    color: #2d7dd8;
  }
`;

class SidePanelColorAdjust extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brightness: 0,
      contrast: 1,
      saturation: 1,
    };
  }

  componentDidMount() {
    this.update();
  }

  setBrightness(val, { animating = true } = {}) {
    this.setState({ brightness: val }, () => {
      this.props.setColorAdjust({ ...this.state, pushHistory: !animating });
    });
  }

  setContrast(val, { animating = true } = {}) {
    this.setState({ contrast: val }, () => {
      this.props.setColorAdjust({ ...this.state, pushHistory: !animating });
    });
  }

  setSaturation(val, { animating = true } = {}) {
    this.setState({ saturation: val }, () => {
      this.props.setColorAdjust({ ...this.state, pushHistory: !animating });
    });
  }

  update() {
    this.setState(this.props.getColorAdjust());
  }

  render() {
    return (
      <SidePanel
        title="Adjust Color"
        showCloseButton
        onClose={this.props.onClose}
      >
        <InputHeader>
          <InputTitle>Brightness</InputTitle>
          <InputReset
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.setBrightness(0, { animating: false });
            }}
          >
            Reset
          </InputReset>
        </InputHeader>
        <input
          type="range"
          min={-1}
          max={1}
          step={2 / 100}
          value={this.state.brightness}
          onChange={(e) => {
            this.setBrightness(e.target.value, { animating: true });
          }}
          onMouseUp={(e) => {
            this.setBrightness(e.target.value, { animating: false });
          }}
          onKeyUp={(e) => {
            this.setBrightness(e.target.value, { animating: false });
          }}
        />
        <InputHeader>
          <InputTitle>Contrast</InputTitle>
          <InputReset
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.setContrast(1, { animating: false });
            }}
          >
            Reset
          </InputReset>
        </InputHeader>
        <input
          type="range"
          min={0}
          max={2}
          step={2 / 100}
          value={this.state.contrast}
          onChange={(e) => {
            this.setContrast(e.target.value, { animating: true });
          }}
          onMouseUp={(e) => {
            this.setContrast(e.target.value, { animating: false });
          }}
          onKeyUp={(e) => {
            this.setContrast(e.target.value, { animating: false });
          }}
        />
        <InputHeader>
          <InputTitle>Saturation</InputTitle>
          <InputReset
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.setSaturation(1, { animating: false });
            }}
          >
            Reset
          </InputReset>
        </InputHeader>
        <input
          type="range"
          min={0}
          max={2}
          step={2 / 100}
          value={this.state.saturation}
          onChange={(e) => {
            this.setSaturation(e.target.value, { animating: true });
          }}
          onMouseUp={(e) => {
            this.setSaturation(e.target.value, { animating: false });
          }}
          onKeyUp={(e) => {
            this.setSaturation(e.target.value, { animating: false });
          }}
        />
      </SidePanel>
    );
  }
}

SidePanelColorAdjust.propTypes = {
  getColorAdjust: PropTypes.func,
  setColorAdjust: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

SidePanelColorAdjust.defaultProps = {
  getColorAdjust: () => {},
  setColorAdjust: () => {},
};

export default SidePanelColorAdjust;
